import { getEmailContext, getEmailSubject, getEmailFrom, getEmailDate } from '../outlook';
/**
 * Host adapter for Microsoft Outlook
 */
export class OutlookAdapter {
    hostType = 'outlook';
    async getDocumentContext() {
        const content = await getEmailContext();
        return {
            content,
            metadata: {
                source: 'outlook-email',
                subject: getEmailSubject(),
                from: getEmailFrom(),
                date: getEmailDate(),
            },
        };
    }
    getDeploymentType() {
        return 'AddinOutlookEmailAssistant';
    }
}
